<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-toolbar color="#313a46">
          <v-card-title class="text-h5 white--text">{{ labelBtn }}</v-card-title>
        </v-toolbar>
        <v-card-text>
          <v-container>
            <v-form ref="form">
              <v-row>
                <v-col v-if="labelBtn == 'Editar'" class="d-flex" cols="12" sm="12">
                  <v-text-field v-model="itensForm.nome" label="Razão Social" disabled></v-text-field>
                </v-col>
                <v-col class="d-flex" cols="12" sm="12">
                  <v-text-field
                    v-mask-cnpj
                    v-model="itensForm.cnpj"
                    label="CNPJ"
                    :rules="[rules.required, rules.maxNumber]"
                    required
                  ></v-text-field>
                </v-col>
                <v-col class="d-flex" cols="12" sm="12">
                  <v-select
                    label="Segmento"
                    :items="segmento"
                    item-text="text"
                    item-value="value"
                    v-model="itensForm.cod_band"
                    dense
                    :rules="[rules.required]"
                    required
                  ></v-select>
                </v-col>
                <v-col class="d-flex" cols="12" sm="12">
                  <v-select
                    label="Status"
                    :items="status"
                    item-text="text"
                    item-value="value"
                    v-model="itensForm.ativo"
                    dense
                    :rules="[rules.required]"
                    required
                  ></v-select>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn outlined class="white--text btn-form" color="error" @click="closeModal('close')">FECHAR</v-btn>
          <v-btn
            class="white--text mr-5 btn-form"
            :color="labelBtn == 'Cadastrar' ? '#313a46' : 'warning'"
            @click="labelBtn == 'Cadastrar' ? createDespesa() : updateDespesa()"
          >{{ labelBtn }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import toast from "@/commom/toast";
import DespesaCnpj from "@/services/http/rpa/DespesaCnpj.js";
export default {
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    labelBtn: {
      type: String
    },
    itemModal: {
      type: Object
    }
  },

  data() {
    return {
      itensForm: {
        cnpj: ""
      },
      status: [
        { text: "Ativo", value: "true" },
        { text: "Inativo", value: "false" }
      ],
      segmento: [
        { text: "2 Rodas", value: "2" },
        { text: "4 Rodas", value: "4" }
      ],
      rules: {
        required: value => !!value || "Campo obrigatório.",
        maxNumber: value =>
          value.length == 18 || `O campo deve conter 14 digitos`
      }
    };
  },

  watch: {
    itemModal(value) {
      this.itensForm = { ...value };
      this.itensForm.ativo = this.itensForm.ativo.toString();
      this.itensForm.cnpj = this.itensForm.cnpj_completo.replace(
        /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
        "$1.$2.$3/$4-$5"
      );
    },
    labelBtn(value) {
      if (value === "Cadastrar") {
        this.itensForm = {};
      }
    }
  },

  methods: {
    async createDespesa() {
      if (this.$refs.form.validate()) {
        const sendForm = { ...this.itensForm };
        sendForm.cnpj = this.itensForm.cnpj.replace(/\D/g, "");
        sendForm.ativo = sendForm.ativo === "false" ? false : true;
        try {
          await DespesaCnpj().store(sendForm);
          toast("success", "Cadastrado com sucesso");
        } catch (e) {
          toast("error", e.message);
        } finally {
          this.closeModal("refresh");
          this.$refs.form.reset();
        }
      }
    },

    async updateDespesa() {
      if (this.$refs.form.validate()) {
        const sendForm = { ...this.itensForm };
        sendForm.cnpj = sendForm.cnpj_completo.replace(/\D/g, "");
        sendForm.ativo = sendForm.ativo === "false" ? false : true;
        try {
          await DespesaCnpj(sendForm.id).update(sendForm);
          toast("success", "Alterado com sucesso");
        } catch (e) {
          toast("error", e.message);
        } finally {
          this.closeModal("refresh");
        }
      }
    },

    closeModal(value) {
      this.$emit("close", value);
    }
  }
};
</script>

<style>
</style>